import { getCobradores, createCobrador, updateCobrador, deleteCobrador } from '../models/cobradorModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchCobradores(page, perPage) {
  try {
    const response = await getCobradores(page, perPage);
    return {
      cobrador: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching cobradores:", error);
    Swal.fire('Error', 'No se pudieron cargar los cobradores', 'error');
    return null;
  }
}

export async function saveCobrador(cobrador, currentCobradorId) {
  try {
    if (currentCobradorId) {
      await updateCobrador(currentCobradorId, cobrador);
      toasts.add({
        title: 'Éxito',
        description: 'Cobrador guardado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createCobrador(cobrador);
      toasts.add({
        title: 'Éxito',
        description: 'Cobrador creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving cobrador:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el cobrador',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeCobrador(id) {
  try {
    await deleteCobrador(id);
    toasts.add({
      title: 'Éxito',
      description: 'Cobrador eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting cobrador:", error);
    Swal.fire('Error', 'No se pudo eliminar el cobrador', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'cobrador'
export function subscribeToCobradores(searchQuery, handleSearch) {
  pb.collection('cobrador').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromCobradores() {
  pb.collection('cobrador').unsubscribe('*');
}

export async function searchCobradores(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('cobrador').getList(page, perPage, {
      filter: `nombre ~ "${query}"`, // Búsqueda por el campo 'nombre'
    });
    return {
      cobrador: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching cobradores:", error);
    Swal.fire('Error', 'No se pudieron buscar los cobradores', 'error');
    return null;
  }
}